export default "__VITE_ASSET__BIBeSDql__"